import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import CustomDrawingControls from './CustomDrawingControls';
import { ServiceAreaType } from '../constants';
import { ServiceAreaShapePayload, useDrawingManager } from '../hooks/useDrawingManager';
import { UndoRedoControl } from './UndoRedoControl';

interface ExistingShape {
  type: ServiceAreaType;
  vertices?: [number, number][];
  centroid?: [number, number];
  range?: number;
  color: string;
}

interface DrawingWrapperProps {
  color?: string;
  onShapeComplete?: (shape: ServiceAreaShapePayload) => void;
  initialData?: {
    type: ServiceAreaType;
    vertices?: [number, number][];
    centroid?: [number, number];
    range?: number;
  };
  onShapeClear?: () => void;
  existingShapes?: ExistingShape[];
  showExistingShapes?: boolean;
  onToggleExistingShapes?: (visible: boolean) => void;
  showControls?: boolean;
}

const DrawingWrapper = ({
  color,
  onShapeComplete,
  initialData,
  onShapeClear,
  existingShapes,
  showExistingShapes = true,
  showControls = true
}: DrawingWrapperProps) => {
  const { controller, activeMode, hasCurrentFeature, clearCurrentFeature } = useDrawingManager(
    color,
    onShapeComplete,
    initialData,
    onShapeClear,
    existingShapes,
    showExistingShapes
  );

  if (!controller) return null;

  return (
    <>
      {showControls && (
        <>
          <MapControl position={ControlPosition.TOP_RIGHT}>
            <CustomDrawingControls
              controller={controller}
              activeMode={activeMode}
              hasCurrentFeature={hasCurrentFeature}
            />
          </MapControl>
          <div
            className="absolute top-[54px] right-2 rounded-md border border-borderGray
           bg-white hover:border-secondary">
            <UndoRedoControl hasCurrentFeature={hasCurrentFeature} onClearOverlay={clearCurrentFeature} />
          </div>
        </>
      )}
    </>
  );
};

export default DrawingWrapper;
